import angular from "angular";

import MaintenanceService from "./MaintenanceService";

import dcModal from "modules/dc-ui/dc-modal";
import ConfigService from "app/services/ConfigService";
import Events from "app/services/Events";

export default angular.module("services.Maintenance", [dcModal,ConfigService,Events])
    .service("MaintenanceService", MaintenanceService)
    .name;



// WEBPACK FOOTER //
// ./src/ui/app/services/MaintenanceService/index.js